import React from 'react';
import { Modal, Button, ListGroup, Image, Row, Col } from 'react-bootstrap';
import { FullEquipment, EquipmentToEquipmentComplementaryItem, EquipmentToConsumableComplementaryItem } from '../interfaces';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

interface EquipmentDetailModalProps {
  show: boolean;
  onHide: () => void;
  equipment: FullEquipment | null;
  allEquipment: FullEquipment[]; // נשאר לצורך קומפטיביליות, אך לא בשימוש ישיר יותר
}

const EquipmentDetailModal: React.FC<EquipmentDetailModalProps> = ({ show, onHide, equipment, allEquipment }) => {
  if (!equipment) {
    return null;
  }

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>פרטי ציוד: {equipment.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          {equipment.image_url && (
            <Col md={4} className="text-center mb-3">
              <Image src={equipment.image_url} alt={equipment.name} fluid rounded thumbnail />
            </Col>
          )}
          <Col md={equipment.image_url ? 8 : 12}>
            <ListGroup variant="flush">
              <ListGroup.Item><strong>קטגוריה:</strong> {equipment.category_name}</ListGroup.Item>
              <ListGroup.Item><strong>תת-קטגוריה:</strong> {equipment.subcategory_name}</ListGroup.Item>
              <ListGroup.Item><strong>כמות במלאי:</strong> {equipment.quantity}</ListGroup.Item>
              <ListGroup.Item><strong>כמות בקייס:</strong> {equipment.case_quantity || 'N/A'}</ListGroup.Item>
              <ListGroup.Item><strong>ציוד כבד:</strong> {equipment.is_heavy ? 'כן' : 'לא'}</ListGroup.Item>
              {/* נקודה 5: הוספת כמות זמינה - נדרש להעביר כ-prop או לבצע קריאת API */}
              {/* כרגע אין לי את הנתון הזה ישירות כאן, אבל אם היה, הייתי מציג אותו: */}
              {/* <ListGroup.Item><strong>כמות זמינה:</strong> {equipment.available_quantity || 'N/A'}</ListGroup.Item> */}
              <ListGroup.Item>
                <strong>מספרים סידוריים:</strong>{' '}
                {equipment.serial_numbers && equipment.serial_numbers.length > 0 ? (
                  equipment.serial_numbers.map(sn => sn.serial_number).join(', ')
                ) : (
                  'אין'
                )}
              </ListGroup.Item>
              <ListGroup.Item><strong>מיקום במחסן:</strong> {equipment.location_in_warehouse || 'אין'}</ListGroup.Item>
              <ListGroup.Item><strong>תקול?</strong> {equipment.is_defective ? 'כן' : 'לא'}</ListGroup.Item>
              {equipment.is_defective && (
                <ListGroup.Item><strong>תיאור תקלה:</strong> {equipment.defect_description || 'אין'}</ListGroup.Item>
              )}
              <ListGroup.Item><strong>הערות:</strong> {equipment.notes || 'אין'}</ListGroup.Item>
              
              {equipment.complementary_items && equipment.complementary_items.length > 0 ? (
                <ListGroup.Item>
                  <strong>ציוד משלים:</strong>
                  <ul className="list-unstyled mb-0">
                    {equipment.complementary_items.map((item: EquipmentToEquipmentComplementaryItem) => (
                      <li key={item.id || `${item.main_equipment}-${item.complementary_equipment}`}>
                        {item.quantity}x {item.complementary_equipment_name || `ID: ${item.complementary_equipment}`}
                        {item.complementary_equipment_category_name && ` (${item.complementary_equipment_category_name})`}
                      </li>
                    ))}
                  </ul>
                </ListGroup.Item>
              ) : (
                <ListGroup.Item><strong>ציוד משלים:</strong> אין</ListGroup.Item>
              )}

              {equipment.complementary_consumable_items && equipment.complementary_consumable_items.length > 0 ? (
                <ListGroup.Item>
                  <strong>מתכלים משלימים:</strong>
                  <ul className="list-unstyled mb-0">
                    {equipment.complementary_consumable_items.map((item: EquipmentToConsumableComplementaryItem) => (
                      <li key={item.id || `${item.main_equipment}-${item.consumable}`}>
                        {item.quantity}x {item.consumable_name || `ID: ${item.consumable}`}
                      </li>
                    ))}
                  </ul>
                </ListGroup.Item>
              ) : (
                <ListGroup.Item><strong>מתכלים משלימים:</strong> אין</ListGroup.Item>
              )}
            </ListGroup>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          <FontAwesomeIcon icon={faTimes} className="me-1" />
          סגור
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EquipmentDetailModal;
